import { cn } from "@/lib/utils";

type Employee = {
  employeeName: string;
  totalConversations: number;
  avgSeconds: number;
  p50: number;
};

type Props = {
  employees: Employee[];
};

const formatTime = (seconds: number): string => {
  const totalMinutes = Math.round(seconds / 60);
  if (totalMinutes < 60) {
    return `${totalMinutes}m`;
  }
  const hours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;
  return `${hours}h ${remainingMinutes}m`;
};

const EmployeeRow = ({
  employee,
  isLast = false,
}: {
  employee: Employee;
  isLast?: boolean;
}) => (
  <div
    className={cn(
      "flex items-center justify-between gap-4 pb-2",
      !isLast && "border-b border-border"
    )}
  >
    <span className="flex-1 truncate text-sm text-palomma-secondary">
      {employee.employeeName}
    </span>
    <span className="min-w-[40px] text-right text-sm text-muted-foreground">
      {employee.totalConversations}
    </span>
    <span className="min-w-[70px] text-right text-sm text-muted-foreground">
      {formatTime(employee.avgSeconds)}
    </span>
    <span className="min-w-[70px] text-right text-sm font-semibold text-palomma-secondary">
      {formatTime(employee.p50)}
    </span>
  </div>
);

const HumanResponseTimeCard = ({ employees }: Props) => {
  return (
    <div className="h-full rounded-2xl border border-border bg-card p-6">
      <h3 className="mb-4 text-sm font-semibold text-palomma-secondary">
        Tiempo de primera respuesta
      </h3>

      <div className="mb-2 flex items-center justify-between gap-4 border-b-2 border-border pb-2">
        <span className="flex-1 text-xs font-semibold text-muted-foreground">Asesor</span>
        <span className="min-w-[40px] text-right text-xs font-semibold text-muted-foreground">
          Conv.
        </span>
        <span className="min-w-[70px] text-right text-xs font-semibold text-muted-foreground">
          Promedio
        </span>
        <span className="min-w-[70px] text-right text-xs font-semibold text-muted-foreground">
          Mediana
        </span>
      </div>

      <div className="flex flex-col gap-1">
        {employees.length === 0 ? (
          <p className="py-4 text-center text-sm text-muted-foreground">Sin datos disponibles</p>
        ) : (
          employees.map((employee, index) => (
            <EmployeeRow
              key={employee.employeeName}
              employee={employee}
              isLast={index === employees.length - 1}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default HumanResponseTimeCard;
